import { createSelector } from '@reduxjs/toolkit';
import { selectWithCommission } from 'shared/selectors/jsonQuery';

export const selectWithCommissionFilter = createSelector(selectWithCommission, value => ({
  label: 'Без комиссии',
  value: value === 0,
}));
